import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Col, Row } from "antd";

import faqApi from "../../../apis/Faq.api";
import { setLoading } from "../../../redux/store/common/commonDuck";

const FaqComponent = ({ type = "", searchKeyword = "", setSearchKeyword }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [faqCategory, setFaqCategory] = useState("");
  const [faqDetail, setFaqDetail] = useState("");
  const [faqIndex, setFaqIndex] = useState(0);
  const [faqBody, setFaqBody] = useState("");

  const [faqCategoryList, setFaqCategoryList] = useState([]);
  const [faqSubList, setFaqSubList] = useState([]);
  const [faqList, setFaqList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [searchShow, setSearchShow] = useState("");

  const scrollView = useRef();
  const [isScrollBottom, setIsScrollBottom] = useState(false);

  const [pageSize, setPageSize] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    getFaqRead();
  }, []);

  useEffect(() => {
    if (faqSubList?.length > 0) {
      getFaqReadList({
        index: 0,
      });
    }
  }, [faqSubList]);

  useEffect(() => {
    setPageSize(20);
    if (scrollView.current) {
      scrollView.current.scrollTop = 0;
    }
    getSearchFaqList(searchKeyword);
    if (searchKeyword?.length === 0) {
      setSearchShow("");
    }
  }, [searchKeyword]);

  /**
   * faq category 가져오기
   * @returns {Promise<void>}
   */
  const getFaqRead = async () => {
    const param = {
      userId: user.id === 724 ? 1 : user.id,
    };
    const res = await faqApi.readAll(param);
    if (res.code === 200) {
      setFaqCategoryList(res.result);
      setFaqCategory(res.result[0].category_id);
      setFaqSubList(res.result[0].subCategoryList);
      setFaqDetail(res.result[0].subCategoryList[0]?.category_id);
    }
  };

  /**
   * 카테고리에 따른 리스트 보여주기
   * @param props
   * @returns {Promise<void>}
   */
  const getFaqReadList = async (props) => {
    let param = {
      category1: faqCategory,
      category2: faqSubList[props?.index]?.category_id,
      search_word: "",
      offset: 0,
      pageSize: pageSize ? pageSize : 20,
      userId: user.id === 724 ? 1 : user.id,
    };
    const res = await faqApi.searchFaq(param);
    if (res.code === 200) {
      // console.log(res);
      setTotalCount(res.result.totalCnt);
      setFaqList(res.result.faqList);
      setIsScrollBottom(false);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  /**
   * 검색 결과 가져오기
   * @param searchKeyword
   * @returns {Promise<void>}
   */
  const getSearchFaqList = async (searchKeyword) => {
    let param = {
      category1: "",
      category2: "",
      search_word: searchKeyword,
      offset: 0,
      pageSize: pageSize ? pageSize : 10,
      userId: user.id === 724 ? 1 : user.id,
    };
    const res = await faqApi.searchFaq(param);
    if (res.code === 200) {
      setSearchList(res.result);
      setIsScrollBottom(false);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  /**
   * faq 버튼 클릭
   * @param e
   */
  const handleFaq = (e, idx) => {
    if (e.currentTarget.name === "category") {
      setFaqCategory(e.currentTarget.id);
      setFaqSubList(faqCategoryList[idx].subCategoryList);
      setFaqDetail(
        faqCategoryList[idx].subCategoryList[0]?.category_id
          ? faqCategoryList[idx].subCategoryList[0]?.category_id
          : "",
      );
    } else if (e.currentTarget.name === "detail") {
      setFaqDetail(e.currentTarget.id);
      setPageSize(20);
      setFaqIndex(idx);
      getFaqReadList({
        index: idx,
      });
    }
  };

  /**
   * 무한 스크롤
   * @param e
   */
  const handleScrollInfinity = () => {
    if (!scrollView.current) {
      return;
    }
    if (
      scrollView.current.scrollHeight <=
      scrollView.current.scrollTop + scrollView.current.clientHeight + 5
    ) {
      if (totalCount >= pageSize) {
        setIsScrollBottom(true);
      } else {
        setIsScrollBottom(false);
      }
      if (searchKeyword) {
        if (searchList?.totalCnt >= pageSize) {
          setIsScrollBottom(true);
        }
      }
    } else {
      setIsScrollBottom(false);
    }
  };
  // 스크롤이 바닥에 닿았을 때 조건 처리
  useEffect(() => {
    if (isScrollBottom) {
      setIsLoading(true);
      setPageSize(pageSize + 20);
    }
  }, [isScrollBottom]);

  // faq 스크롤 처리
  useEffect(() => {
    if (totalCount >= pageSize) {
      getFaqReadList({ index: faqIndex });
    } else {
      let count = pageSize - totalCount + 1;
      if (count > 0 && count < 20) {
        setPageSize(pageSize + count);
        getFaqReadList({ index: faqIndex });
      }
    }
  }, [faqIndex, pageSize]);

  // 검색 스크롤 처리
  useEffect(() => {
    if (searchKeyword?.length > 0 && searchList?.totalCnt) {
      if (searchList?.totalCnt >= pageSize) {
        getSearchFaqList(searchKeyword);
      } else {
        let count = pageSize - searchList?.totalCnt + 1;
        if (count > 0 && count < 20) {
          setPageSize(pageSize + count);
          getSearchFaqList(searchKeyword);
        }
      }
    }
  }, [searchKeyword, searchList, pageSize]);

  if (searchKeyword?.length > 0) {
    return (
      <>
        <div
          className={`faq-component`}
          ref={scrollView}
          onScroll={(e) => handleScrollInfinity(e)}
        >
          <p>
            <span>{searchKeyword}</span> 검색결과{" "}
            <span>{searchList?.totalCnt}</span>건
          </p>
          {searchList?.faqList?.map((item, idx) => {
            const questionText = item?.question.replace(
              searchKeyword,
              `<span>${searchKeyword}</span>`,
            );
            return (
              <div key={`${searchKeyword} 검색 결과 FAQ ${idx}`}>
                {questionText && (
                  <Row
                    style={{
                      display: "flex",
                      gap: "8px",
                      rowGap: "8px",
                      flexWrap: "nowrap",
                      width: "100%",
                    }}
                  >
                    <img
                      src={`${
                        process.env.REACT_APP_HOST
                      }/assets/images/salesManage/${
                        searchShow === `${idx}` ? "fold" : "expand"
                      }.png`}
                      alt={`faq 접기열기 아이콘`}
                      width={20}
                      height={20}
                    />
                    <div
                      className={`helper-body-each`}
                      onClick={() => {
                        if (searchShow === `${idx}`) {
                          setSearchShow("");
                        } else {
                          setSearchShow(`${idx}`);
                        }
                      }}
                      style={{
                        width: "100%",
                        maxWidth: "92%",
                        padding: 0,
                      }}
                    >
                      <p
                        dangerouslySetInnerHTML={{
                          __html: questionText,
                        }}
                        className={`faq-question-font`}
                        style={
                          searchShow === `${idx}`
                            ? {
                                fontWeight: "bold",
                                whiteSpace: "pre-wrap",
                              }
                            : {}
                        }
                      />
                      <span
                        className={`gray-font`}
                        id={`faq-answer-example`}
                        style={
                          searchShow === `${idx}`
                            ? {
                                whiteSpace: "pre-wrap",
                                color: "#495057",
                              }
                            : {}
                        }
                      >
                        {item.answer}
                      </span>
                    </div>
                  </Row>
                )}
              </div>
            );
          })}
        </div>
        {type !== "call" && (
          <Button className={`go-back`}>
            <img
              onClick={() => setSearchKeyword("")}
              alt={"뒤로가기 버튼"}
              src={`${process.env.REACT_APP_HOST}/assets/images/memberManage/goback.png`}
            />
          </Button>
        )}
      </>
    );
  } else {
    return (
      <div
        className={`faq-component`}
        ref={scrollView}
        onScroll={(e) => handleScrollInfinity(e)}
      >
        {/* 대카테고리 */}
        <div className={`order-component-each`}>
          <div className={`order-component-each-detail`}>
            <Row style={{ width: "100%", gap: "8px", rowGap: "8px" }}>
              {faqCategoryList.map((item, idx) => (
                <Button
                  className={`faq-button
                                            ${
                                              faqCategory === item.category_id
                                                ? "clicked"
                                                : ""
                                            }`}
                  id={item.category_id}
                  name={"category"}
                  onClick={(e) => handleFaq(e, idx)}
                  key={`faq-category-list-${item.category_id}-${idx}`}
                  loading={isLoading}
                >
                  {item.category_name}
                </Button>
              ))}
            </Row>
          </div>
        </div>

        {/* FAQ 상세 버튼 */}
        {faqSubList?.length > 0 && (
          <div className={`order-component-each`}>
            <div className={`order-component-each-detail`}>
              <Row style={{ width: "100%", gap: "8px", rowGap: "8px" }}>
                {faqSubList.map((item, idx) => (
                  <Button
                    className={`faq-button-detail
                                            ${
                                              faqDetail ===
                                              `${item.category_id}`
                                                ? "clicked"
                                                : ""
                                            }`}
                    id={`${item.category_id}`}
                    name={"detail"}
                    onClick={(e) => handleFaq(e, idx)}
                    key={`faq-sub-list-${idx}`}
                    loading={isLoading}
                  >
                    {item.category_name}
                  </Button>
                ))}
              </Row>
            </div>
          </div>
        )}

        {/* FAQ 내용 */}
        {faqDetail !== "" && (
          <div className={`order-component-each`}>
            <div className={`order-component-each-detail`}>
              {faqList.map((item, idx) => (
                <Col key={`faq-body-list-${idx}`}>
                  <Row
                    className={`faq-question ${
                      faqBody === `faq-${idx}` ? "clicked" : ""
                    }`}
                    onClick={() => {
                      if (faqBody === `faq-${idx}`) {
                        setFaqBody("");
                      } else {
                        setFaqBody(`faq-${idx}`);
                      }
                    }}
                  >
                    <img
                      src={`${
                        process.env.REACT_APP_HOST
                      }/assets/images/salesManage/${
                        faqBody === `faq-${idx}` ? "fold" : "expand"
                      }.png`}
                      alt={`faq 접기열기 아이콘`}
                    />
                    <span>{item.question}</span>
                  </Row>
                  {faqBody === `faq-${idx}` && (
                    <Row
                      className={`faq-answer`}
                      style={{ whiteSpace: "pre-line" }}
                    >
                      <span>{item.answer}</span>
                    </Row>
                  )}
                </Col>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
};
export default FaqComponent;
